import { IAppState } from 'shared/common/state';

export const isAutorisationPopupOpenSelector = (state: IAppState): boolean => {
  return state.consultantCianChat?.isAutorisationPopupOpened || false;
};
